import React, { FC } from 'react';
import { FormatChangeSiteFormProps } from './FormatChangeSiteFormProps';
import LocationInfoFields from '../LocationInfoFields';
import SiteInfoFields from '../SiteInfoFields';

const FormatChangeSiteForm: FC<FormatChangeSiteFormProps> = ({
  countries,
  BUList,
  isep,
  onBUChange,
  onCountryChange,
  transactionType,
  isLeasedFromAnotherIngkaCompany,
  currencyRate,
  currency,
  isEdit,
}) => {
  return (
    <>
      <LocationInfoFields
        countries={countries}
        buCode
        buCodeRequired
        BUList={BUList}
        onBUChange={onBUChange}
        onCountryChange={onCountryChange}
        isep={isep}
        isEdit={isEdit}
      />
      <SiteInfoFields
        unitType
        land
        lease
        newUnitType
        transactionType={transactionType}
        isLeasedFromAnotherIngkaCompany={isLeasedFromAnotherIngkaCompany}
        site
        building
        unit
        unitCategoryDisabled
        currencyRate={currencyRate}
        currency={currency}
      />
    </>
  );
};

export default FormatChangeSiteForm;
